import React, { useEffect, useState } from "react";
import axios from "axios";
import "./dashboard.css";
import "./categories.css";
import SideBar from "../../components/SideBar";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

function Dashboard() {
  const [topItems, setTopItems] = useState([]);
  const [salesCount, setSalesCount] = useState(0); // Now represents total quantity
  const [totalAmount, setTotalAmount] = useState(0);
  const [cashTotal, setCashTotal] = useState(0);
  const [creditTotal, setCreditTotal] = useState(0);
  const [ePaymentTotal, setEPaymentTotal] = useState(0);
  const [cardTotal, setCardTotal] = useState(0); // Added for today's card payments
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

    axios
      .get("https://nyatapol.biz/cafe_resturant/api/reports/getalldata")
      .then((res) => {
        const invoices = res.data.invoices || [];
        const payments = res.data.payments || [];
        const orders = res.data.orders || [];

        // Filter today's invoices
        const todayInvoices = invoices.filter((inv) =>
          inv.issued_at.startsWith(today)
        );

        setTotalAmount(
          todayInvoices.reduce(
            (sum, inv) => sum + parseFloat(inv.grand_total),
            0
          )
        );

        // Filter today's payments
        const todayPayments = payments.filter((p) =>
          p.payment_date.startsWith(today)
        );

        let cash = 0,
          credit = 0,
          epayment = 0,
          card = 0; // Added for card payments

        todayPayments.forEach((p) => {
          const amt = parseFloat(p.amount_paid || 0);
          if (p.payment_method === "Cash") cash += amt;
          else if (p.payment_method === "Credit") credit += amt;
          else if (p.payment_method === "Card")
            card += amt; // Calculate Card Payment
          else epayment += amt;
        });

        setCashTotal(cash);
        setCreditTotal(credit);
        setEPaymentTotal(epayment);
        setCardTotal(card); // Set Today's Card Payment

        // Filter today's orders
        const todayOrders = orders.filter((order) =>
          order.created_on.startsWith(today)
        );

        // Total quantity of all items sold
        let totalQty = 0;

        // Calculate top-selling item by quantity
        const itemSales = {};
        todayOrders.forEach((order) => {
          order.items.forEach((item) => {
            const name = item.item_name || "Unnamed";
            const qty = parseFloat(item.quantity || 0);

            totalQty += qty;

            if (!itemSales[name]) itemSales[name] = 0;
            itemSales[name] += qty;
          });
        });

        setSalesCount(totalQty); // ✅ Total items sold

        const sortedItems = Object.entries(itemSales)
          .sort((a, b) => b[1] - a[1])
          .map(([itemName, quantity]) => ({ itemName, quantity }));

        setTopItems(sortedItems.slice(0, 1)); // Top 1 item
      })
      .catch((err) => {
        console.error("Failed to fetch dashboard data:", err);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <SideBar />
      <Header />
      <div className="MainContainer">
        <div className="DashboardBox">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="dashboard-cards">
              <div className="dashboard-card">
                <h3>Total Sales Today</h3>
                <p>{salesCount} pcs</p>
              </div>
              <div className="dashboard-card">
                <h3>Total Amount</h3>
                <p>Rs. {totalAmount.toFixed(2)}</p>
              </div>
              <div className="dashboard-card">
                <h3>Cash Payment</h3>
                <p>Rs. {cashTotal.toFixed(2)}</p>
              </div>
              <div className="dashboard-card">
                <h3>Credit Payment</h3>
                <p>Rs. {creditTotal.toFixed(2)}</p>
              </div>
              <div className="dashboard-card">
                <h3>E-Payment</h3>
                <p>Rs. {ePaymentTotal.toFixed(2)}</p>
              </div>
              {/* Added Today's Card Payment */}
              <div className="dashboard-card">
                <h3>Card Payment Today</h3>
                <p>Rs. {cardTotal.toFixed(2)}</p>
              </div>
              <div className="dashboard-card">
                <h3>Top Item Sold</h3>
                {topItems.length > 0 ? (
                  <p>
                    {topItems[0].itemName}: {topItems[0].quantity} pcs
                  </p>
                ) : (
                  <p>No sales today</p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Dashboard;
